import { __decorate, __metadata } from "tslib";
import { ChargeTypeEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsOptional } from 'class-validator';
import { ServiceChargeExposeGroup } from '../interface';
export class ReadBaseChargeDto {
}
__decorate([
    ApiProperty(),
    IsOptional({ groups: [ServiceChargeExposeGroup.PATCH] }),
    IsEnum(ChargeTypeEnum, { always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadBaseChargeDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional({ always: true }),
    IsEnum(ChargeTypeEnum, { always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadBaseChargeDto.prototype, "externalType", void 0);
//# sourceMappingURL=ReadBaseChargeDto.js.map